<div class="box">
  <div class="left">
    <div class="header">
      <div class="menu" *ngFor="let menu of shuttle_box.menu_list">
        <span class="under-line" [class.under-line-color]="menu.id == current_menu_id" (click)="switchTab(menu.id)">{{ menu.name }}</span>
      </div>
    </div>
    <div class="content">
      <!--      <nz-spin nzSimple></nz-spin>-->
      <ul class="list">
        <li *ngFor="let tag of shuttle_box.tab_list" (click)="selectedTag(tag)">{{ tag.title }}</li>
      </ul>
    </div>
  </div>
  <div class="right">
    <div class="header">
      <div class="title">已选<span>（三项）</span></div>
      <a class="button" nz-button nzType="link" (click)="clearSelected()">清空</a>
    </div>
    <div class="content">
      <nz-input-group nzSearch [nzAddOnAfter]="suffixButton">
        <input type="text" nz-input placeholder="最多20个标签, 每个标签不超过10个字, 可用空格分隔" />
      </nz-input-group>
      <ng-template #suffixButton>
        <button nz-button nzType="primary" nzSearch>添加</button>
      </ng-template>
      <div *ngIf="shuttle_box.selected_tab_list.length != 0">
        <nz-tag
          class="tag"
          [nzColor]="'blue'"
          *ngFor="let selected_tag of shuttle_box.selected_tab_list"
          nzMode="closeable"
          (nzOnClose)="handleClose(selected_tag)"
          >{{ selected_tag.title }}</nz-tag
        >
        <!--        <nz-tag [nzColor]="'#2db7f5'">#2db7f5</nz-tag>-->
        <!--        <nz-tag [nzColor]="'#87d068'">#87d068</nz-tag>-->
        <!--        <nz-tag [nzColor]="'#108ee9'">#108ee9</nz-tag>-->
      </div>
    </div>
    <div class="footer">
      <button nz-button nzType="default" class="button">保存为模版</button>
    </div>
  </div>
</div>
